import { render, staticRenderFns } from "./MensagemSomenteVipTeste.vue?vue&type=template&id=4cfe52a3&"
import script from "./MensagemSomenteVipTeste.vue?vue&type=script&lang=js&"
export * from "./MensagemSomenteVipTeste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports